



















import { Component, Watch } from "vue-property-decorator"
import TemplateSubmissionModule from "@/store/modules/submission/TemplateSubmissionModule"
import SurveySubmissionService from "@/services/submission/surveySubmission/SurveySubmissionService"
import SurveySubmissionModule from "@/store/modules/submission/SurveySubmissionModule"
import PasswordProtectionDialog from "@/components/templateSubmission/surveyDataManagement/PasswordProtectionDialog.vue"
import VueTrans from "@/mixins/VueTrans.vue"

@Component({
  components: { PasswordProtectionDialog }
})
export default class ExportList extends VueTrans {
  transKey = "templatesubmission.surveydatamanagement."
  isAsyncExported = { display: false, error: false }

  async exportXlsx(isHarmonizedData = false, password = ""): Promise<void> {
    const templateSubmission = TemplateSubmissionModule.currentSubmission
    if (templateSubmission) {
      const asyncExportedResult = await SurveySubmissionService.exportByTemplateSubmission(templateSubmission, SurveySubmissionModule.filters, isHarmonizedData, password)
      this.isAsyncExported = { display: asyncExportedResult, error: !asyncExportedResult }
    }
    return
  }

  get asyncExportedMessage(): string {
    if (!this.isAsyncExported.error) {
      return "The export is being processed. You will receive an notification when the export is ready."
    } else {
      return "The export has failed."
    }
  }

  get asyncExportedStatus(): string {
    if (!this.isAsyncExported.error) {
      return "success"
    } else {
      return "error"
    }
  }

  get hasAlert(): boolean {
    return this.isAsyncExported.display || this.isAsyncExported.error
  }

  @Watch("isAsyncExported", { deep: true })
  timeout(): void {
    if (this.hasAlert) {
      setTimeout(() => {
        this.isAsyncExported = { display: false, error: false }
      }, 5000)
    }
  }
}
